"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Component_1 = __importDefault(require("../Component"));
const playlistImages_1 = require("./playlistImages");
const getTracksCountString_1 = require("../../utils/tracks/getTracksCountString");
class PlaylistCardComponent extends Component_1.default {
    constructor(id, name, tracksCount) {
        super();
        this.id = id;
        this.name = name;
        this.tracksCount = tracksCount;
    }
    getTemplate() {
        const tracksCountString = (0, getTracksCountString_1.getTracksCountString)(this.tracksCount);
        const smallImageSrc = playlistImages_1.PLAYLIST_IMAGES.small[this.id % playlistImages_1.PLAYLIST_IMAGES.small.length];
        const normalImageSrc = playlistImages_1.PLAYLIST_IMAGES.normal[this.id % playlistImages_1.PLAYLIST_IMAGES.normal.length];
        const bigImageSrc = playlistImages_1.PLAYLIST_IMAGES.big[this.id % playlistImages_1.PLAYLIST_IMAGES.big.length];
        return `
      <li class="playlist__item">
        <picture>
          <source srcset="${smallImageSrc}" media="(max-width: 576px)">
          <source srcset="${bigImageSrc}" media="(max-width: 1440px)">
          <img class="playlist__img" src="${normalImageSrc}" alt="Любимые песни">
        </picture>
        <div class="playlist__content">
          <h3 class="playlist__h3"><a class="playlist__h3__link" href="/">${this.name}</a></h3><span class="playlist__count">${tracksCountString}</span>
        </div>
      </li>
    `;
    }
    addOnClickListener(callback) {
        const link = this.getElement().querySelector('.playlist__h3__link');
        if (!link) {
            throw new Error('.playlist__h3__link is not found');
        }
        link.addEventListener('click', (event) => {
            event.preventDefault();
            callback();
        });
    }
}
exports.default = PlaylistCardComponent;
